// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PriceDimensionClassCombination.yaml
// Generated: 2026-10-20T12:35:32.117Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { PriceDimensionClassCombination } from '@/types/forestry/PriceDimensionClassCombination';

/**
 * PriceDimensionClassCombination Service (Read-Only)
 * Query operations for PriceDimensionClassCombination via the ABP API.
 */
export const priceDimensionClassCombinationService = new ReadOnlyEntityService<PriceDimensionClassCombination>(
  '/api/forestry/pricedimensionclasscombination',
  'PriceDimensionClassCombination',
);
